import { render, staticRenderFns } from "./q-ans-remove-popup.html?vue&type=template&id=784711fb&scoped=true&external"
import script from "./q-ans-remove-popup.js?vue&type=script&lang=js&external"
export * from "./q-ans-remove-popup.js?vue&type=script&lang=js&external"
import style0 from "./q-ans-remove-popup.scss?vue&type=style&index=0&id=784711fb&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "784711fb",
  null
  
)

export default component.exports